import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import Country from '../../../../../../types/country/Country';
import DealershipWriteDTO from '../../../../../../types/dealership/DealershipWriteDTO';
import { CountryService } from '../../../../services/country.service';
import { DealershipService } from '../../../../services/dealership.service';

@Component({
    selector: 'app-update-dealership-dialog',
    templateUrl: './update-dealership-dialog.component.html',
    styleUrls: [ './update-dealership-dialog.component.scss' ],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IconField,
        InputIcon,
        IftaLabelModule,
        Select,
    ]
})
export class UpdateDealershipDialogComponent implements OnInit {
    @Input() visible: boolean = false;
    @Input() dealership: DealershipWriteDTO = new DealershipWriteDTO({});
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() dealershipUpdated: EventEmitter<DealershipWriteDTO> = new EventEmitter<DealershipWriteDTO>();

    public availableCountries: Country[] = [];
    public loading = false;
    public loadingCountries = false;

    constructor(
        private dealershipService: DealershipService,
        private countryService: CountryService,
        private messageService: MessageService
    ) {
    }

    ngOnInit(): void {
        this.loadCountries();
    }

    get saveDisabled(): boolean {
        return !this.dealership.name || !this.dealership.countryId;
    }

    public close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public loadCountries() {
        this.loadingCountries = true;
        this.countryService
            .getAllCountries()
            .then((countries) => {
                this.availableCountries = countries;
            })
            .catch((error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 3000,
                });
            })
            .finally(() => {
                this.loadingCountries = false;
            });
    }

    public updateDealership() {
        this.loading = true;

        this.dealershipService
            .updateDealership(this.dealership)
            .then(() => {
                this.dealershipUpdated.emit(this.dealership);
                this.close();
            })
            .catch((error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 3000,
                });
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
